import { render, staticRenderFns } from "./DownloadFotoOrden.vue?vue&type=template&id=f547e530&scoped=true&"
import script from "./DownloadFotoOrden.vue?vue&type=script&lang=js&"
export * from "./DownloadFotoOrden.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFotoOrden.vue?vue&type=style&index=0&id=f547e530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547e530",
  null
  
)

export default component.exports